import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from 'se-fe-domain-environment';
import { SE_FE_DOMAIN_ENVIRONMENT_OPTIONS, SeFeDomainEnvironmentModule } from 'se-fe-domain-environment';
import * as i2 from '@angular/common/http';

class SeFeApiService {
    constructor(domainEnvironmentService, http) {
        this.domainEnvironmentService = domainEnvironmentService;
        this.http = http;
        // noop
    }
    get(path, options) {
        return this.http.get(this.uri(path), this.getOptions(options));
    }
    post(path, body, options) {
        return this.http.post(this.uri(path), body, this.getOptions(options));
    }
    put(path, body, options) {
        return this.http.put(this.uri(path), body, this.getOptions(options));
    }
    delete(path, options) {
        return this.http.delete(this.uri(path), this.getOptions(options));
    }
    baseUrl() {
        return this.domainEnvironmentService.getUrl('api');
    }
    uri(path) {
        return this.ensureTrailingSlash(this.baseUrl()) + encodeURI(this.ensureNoLeadingSlash(path));
    }
    ensureTrailingSlash(str) {
        if (str.endsWith('/'))
            return str;
        return `${str}/`;
    }
    ensureNoLeadingSlash(str) {
        if (!str.startsWith('/'))
            return str;
        return str.substring(1);
    }
    getOptions(options) {
        options = options || {};
        options.withCredentials = true;
        options.headers = options.headers || {};
        options.headers.Accept = options.headers.Accept || 'application/json';
        return options;
    }
}
SeFeApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeApiService, deps: [{ token: i1.SeFeDomainEnvironmentService }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
SeFeApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.SeFeDomainEnvironmentService }, { type: i2.HttpClient }]; } });

class SeFeApiModule {
    static forRoot(options) {
        return {
            ngModule: SeFeApiModule,
            providers: [
                { provide: SE_FE_DOMAIN_ENVIRONMENT_OPTIONS, useValue: options }
            ]
        };
    }
}
SeFeApiModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeApiModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeApiModule, imports: [SeFeDomainEnvironmentModule] });
SeFeApiModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeApiModule, imports: [[SeFeDomainEnvironmentModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [SeFeDomainEnvironmentModule]
                }]
        }] });

/*
 * Public API Surface of se-fe-api
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeApiModule, SeFeApiService };
